export enum ColorTheme {
  DEFAULT = "theme-default",
  ORANGE = "theme-orange",
  LIGHT_GREEN = "theme-light-green",
  DARK_GREEN = "theme-dark-green",
  LIGHT_BLUE = "theme-light-blue",
  BLUE_GRAY = "theme-blue-gray",
  PURPLE = "theme-purple",
}

export function getColor(kategori: number): ColorTheme {
  switch (kategori) {
    case 3:
      return ColorTheme.PURPLE;
    case 4:
      return ColorTheme.ORANGE;
    case 5:
      return ColorTheme.BLUE_GRAY;
    case 6:
      return ColorTheme.LIGHT_BLUE;
    case 7:
      return ColorTheme.LIGHT_GREEN;
    case 8:
      return ColorTheme.DARK_GREEN;
    default:
      return ColorTheme.DEFAULT;
  }
}
